export const LOAD_CATALOG = 'LOAD_CATALOG'
export const LOADING_CATALOG = 'LOADING_CATALOG'
export const LOAD_CATALOG_SUCCEEDED = 'LOAD_CATALOG_SUCCEEDED'
export const LOAD_CATALOG_FAILED = 'LOAD_CATALOG_FAILED'


export function loadCatalog() {
    return { type: LOAD_CATALOG }
}
